// extracted by mini-css-extract-plugin
export default {"editorTitle":"editor-title_editorTitle__N50Es","icon":"editor-title_icon__nj3LJ","title":"editor-title_title__VwA9q"};